import KlarnaLanding from './KlarnaLanding';

export default KlarnaLanding;
